import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  Box,
  Button,
  ButtonLink,
  Stack,
  Text,
  Heading,
  Columns,
  Column,
  TextLinkButton,
  IconArrowLeft,
  Dialog
} from '@machobear/design-system'
import { breakpoints } from '@machobear/design-system/css'
import { Download } from '@/components/icons'

import useMediaQuery from '@/hooks/use-media-query'
import craigslistVideo from './craigslist-share.mp4'

const ShareByCraigslist = ({ open, onClose, handleDownloadImages, showMainModal }) => {
  const { t } = useTranslation()
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tablet}px)`)

  const handleBack = async () => {
    onClose()
    showMainModal()
  }

  const BackButton = () => {
    return (
      <Button
        variant="transparent"
        size="standard"
        iconPosition="leading"
        icon={<IconArrowLeft />}
        onClick={handleBack}
      >
        {t('common.back', 'Back')}
      </Button>
    )
  }

  return (
    <>
      <Dialog
        id="share-listing-craigslist-dialog"
        title={t('l.listing.view.share.title', 'Share Your Listing')}
        open={open}
        onClose={onClose}
        actionButton={
          isMobile && (
            <Box style={{ width: 87 }}>
              <BackButton />
            </Box>
          )
        }
      >
        <Stack space="large">
          <Box
            width="full"
            height="full"
            component="video"
            src={craigslistVideo}
            data-testid="craigslist-video"
            loop
            autoPlay
            playsInline
            muted
          />
          <Stack space="gutter">
            <Heading level="6" weight="regular">
              {t('l.listing.view.description_copied.title', 'Description Copied!')}
            </Heading>
            <Columns space="xsmall" alignY="center">
              <Column width="content">
                <Box
                  style={{ width: 24, height: 24 }}
                  borderRadius="full"
                  boxShadow="borderNeutralLight"
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                >
                  <Text>1</Text>
                </Box>
              </Column>
              <Column width="content">
                <TextLinkButton onClick={handleDownloadImages}>
                  <Box display="flex" flexDirection="row" gap="xxxsmall" alignItems="center">
                    {t('l.listing.view.download_listing_images.button', 'Download Listing Images')}
                    <Download />
                  </Box>
                </TextLinkButton>
              </Column>
            </Columns>
            <Columns space="xsmall" alignY="center">
              <Column width="content">
                <Box
                  style={{ width: 24, height: 24 }}
                  borderRadius="full"
                  boxShadow="borderNeutralLight"
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                >
                  <Text>2</Text>
                </Box>
              </Column>
              <Column>
                <Text>
                  {t(
                    'l.listing.share_craigslist.paste_description.text',
                    'Paste the content into Craigslist’s listing description form.'
                  )}
                </Text>
              </Column>
            </Columns>
          </Stack>
          <Box display="flex" flexDirection="row" justifyContent="spaceBetween" alignItems="center">
            {!isMobile && (
              <Box style={{ width: 87 }}>
                <BackButton />
              </Box>
            )}
            <Box style={{ width: isMobile ? '100%' : 167 }}>
              <ButtonLink
                href="https://post.craigslist.org/"
                target="_blank"
                variant="solid"
                size="standard"
              >
                {t('l.listing.share_craigslist.open_craigslist.button.text', 'Open Craigslist')}
              </ButtonLink>
            </Box>
          </Box>
        </Stack>
      </Dialog>
    </>
  )
}

export default memo(ShareByCraigslist)
